// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --loader-duration: 1.8s;

  display: contents;
}

button {
  position: relative;
  display: inline-grid;
  grid-auto-flow: column;
  gap: calc(.25rem);
  place-items: center;
  height: calc(2rem);
  padding: calc(.125rem) calc(.75rem);
  overflow: clip;
  font-weight: 700;
  color: var(--button-text-color--default);
  text-transform: uppercase;
  text-wrap: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--button-background-color--default);
  border-color: var(--button-border-color);
  border-style: solid;
  border-width: 1px;
  border-radius: 0.25rem;
  transition: all 200ms ease;
}

button svg {
    color: var(--button-icon-color--default);
  }

button .truncate {
    max-width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

button[aria-disabled] {
    cursor: default;
  }

button.loading {
    cursor: wait;
  }

button.subtle-button--theme-startSession:focus-visible {
        outline: 2px solid #206dd2;
        outline-offset: 2px;
      }

button:hover:not(.loading) {
    color: var(--button-text-color--hover);
    background: var(--button-background-color--hover);
  }

button:hover:not(.loading) svg {
      color: var(--button-icon-color--hover);
    }

button:active:not(.loading) {
    color: var(--button-text-color--active);
    background: var(--button-background-color--active);
  }

button:active:not(.loading) svg {
      color: var(--button-icon-color--active);
    }

button > * {
    pointer-events: none;
  }

.loader {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.loader .loader-inner {
    position: relative;
  }

@keyframes line1 {
    0% {
      left: -100%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 10%;
    }
  }

@keyframes line2 {
    0% {
      left: -150%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 10%;
    }
  }

.loader .line1,
  .loader .line2,
  .loader .background {
    position: absolute;
    bottom: 0;
    height: calc(.25rem);
    transition: background 200ms ease;
  }

.loader .background {
    width: 100%;
    background: var(--loader-background-color);
  }

.loader .line1 {
    background: var(--loader-foreground-color);
    animation: line1 var(--loader-duration) infinite ease-out;
  }

.loader .line2 {
    background: var(--loader-foreground-color);
    animation: line2 var(--loader-duration) infinite ease-in;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
